import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityFilters } from '@/shared/types/entity';
import type { CreateUserData, User } from '@/shared/types/user';
import { usersApi } from '../api';

export interface UserFilters extends EntityFilters {
  role?: string;
  status?: string;
}

export const USERS_DEFAULT_FILTERS: UserFilters = {
  search: '',
  dateRange: null,
  role: '',
  status: '',
};

const initialState = {
  items: [] as User[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 10,
  total: 0,
  lastPage: 1,
  filters: USERS_DEFAULT_FILTERS,
};

const { actions, reducer: usersEntityReducer } = createEntitySlice<
  User,
  UserFilters,
  CreateUserData
>({
  name: 'usersEntity',
  api: usersApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.usersEntity;
    const params: Record<string, unknown> = { page: currentPage, perPage };

    if (filters.search && filters.search.trim()) {
      params.search = filters.search.trim();
    }

    if (filters.dateRange?.start) {
      params.startDate = filters.dateRange.start;
    }

    if (filters.dateRange?.end) {
      params.endDate = filters.dateRange.end;
    }

    if (filters.role && filters.role.trim()) {
      params.role = filters.role;
    }

    if (filters.status && filters.status !== '') {
      params.status = filters.status === 'true' ? 1 : 0;
    }

    return params;
  },
});

export const {
  fetchItems: fetchUsers,
  createItem: createUser,
  updateItem: updateUser,
  deleteItem: deleteUser,
  setPage,
  setPerPage,
  setFilters,
} = actions;

export { usersEntityReducer };
